<template>
<!-- <Sider collapsible :collapsed-width="78" v-model="isCollapsed"> -->
	<Menu ref="shop" theme="dark" :class="menuitemClasses" width="auto" :active-name="active" @on-select="select">
		<MenuItem v-for="(i,index) in menuData" :name="i.path" :key="index">
            <Icon class="menuIcon" :type="i.meta.icon"/>
			<label class="tltleLabel" v-if="!isCollapsed">{{i.name}}</label>
            <!-- <span style="color:red" v-if="i.path == '/myTask'">1234</span> -->
		</MenuItem>
	</Menu>
<!-- </Sider> -->
</template>

<script>
// import Bus from '../../store/Bus.js'
    export default {
        name: "ItSider",
        props:['isCollapsed'],
		computed:{
			menuitemClasses () {
                return [
                    'menu-item',
                    this.isCollapsed ? 'collapsed-menu' : ''
                ]
            },
            menuData(){
                let data=[]
                for(let i in this.menuItem){
                    if(this.menuItem[i].path=='/'+this.$route.path.split('/')[1]){
                        data=this.menuItem[i].children
                    }
                }
                return data
            }
		},
		data(){
			return{
                active : '',
                showsider:true,
                menuItem:[],
                itemParent:1
            }
        },
        watch:{
             $route(to,from){
                this.$nextTick(()=>{
                    this.active = this.$route.path.slice(1).split('/')[1]
                    this.$refs.shop.updateActiveName() 
                })
            }
        },
        methods:{
            select(name){
                this.$router.push('/'+this.$route.path.slice(1).split('/')[0]+'/'+name)
                this.active=name
            },
            initData(){
                this.menuItem = JSON.parse(window.sessionStorage.getItem('tree'))
                this.$nextTick(()=>{
                    this.active=this.$route.path.slice(1).split('/')[1]
                    this.$refs.shop.updateActiveName()
                })
            }
        },
        mounted(){
            this.initData()
        }
    }
</script>

<style lang="scss" scoped>
	.menu-item{
		height: 100%;
	}
	.menu-item span{
        display: inline-block;
        overflow: hidden;
        width: 60px;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: bottom;
        transition: width .2s ease .2s;
        text-align: center;
    }
    .menu-item i{
        transform: translateX(0px);
        transition: font-size .2s ease, transform .2s ease;
        vertical-align: middle;
        font-size: 16px;
    }
    .collapsed-menu span{
        width: 0px;
        transition: width .2s ease;
    }
    .collapsed-menu i{
        transform: translateX(5px);
        transition: font-size .2s ease .2s, transform .2s ease .2s;
        vertical-align: middle;
        font-size: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Sider/ItSider.vue